import './style.css';
import LOGO from 'assets/ActusIcone2025x1024.png';
import { Link, useNavigate } from 'react-router-dom';
import { getparceiro, getadmin } from 'functions/gettabconfig';
import { getNotificacao } from 'functions/getnotificacao';
import { useContext, useEffect, useState } from 'react';
import SelectCidade from 'components/SelectCidade';
import { CidadeContext } from 'services/cidade';


function HOMENAVEGACAO(props) {
  const [logadop, setLogadop] = useState(false);
  const [logadoa, setLogadoa] = useState(false);
  const [temnotificacao, setTemNotificacao] = useState(0);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const { cod_cidade, cidades, setCodCidade} = useContext(CidadeContext);

  const navigate = useNavigate();

  const SalvarCidade = (e) => {
    setCodCidade(e.target.value);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const notificacoes = await getNotificacao();
        setTemNotificacao(notificacoes);
      } catch (error) {
        console.error('Erro ao buscar notificações:', error);
        setTemNotificacao(0);
      }
      setLogadop(getparceiro());
      setLogadoa(getadmin());
    };
    fetchData();

  }, []);

  const goNotificacao = () => {
    navigate('/notificacao');
  }

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  }

  const toggleSection = (section) => {
    if (activeSection === section) {
      setActiveSection('');
    } else {
      setActiveSection(section);
      setSidebarExpanded(true);
    }
  }

  // Adicionar/remover classe do body quando sidebar expandir
  useEffect(() => {
    if (sidebarExpanded) {
      document.body.classList.add('sidebar-expanded');
    } else {
      document.body.classList.remove('sidebar-expanded');
    }
    
    // Cleanup ao desmontar componente
    return () => {
      document.body.classList.remove('sidebar-expanded');
    };
  }, [sidebarExpanded]);

  return (
    <>
      {/* Navbar superior
      <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-custom">
        <div className="container-fluid">
          <button className="navbar-brand border-0 bg-transparent p-0" onClick={() => navigate('/')}>
           
          </button>
          
          <div className="navbar-nav ms-auto d-flex align-items-center">
            {temnotificacao > 0 && (
              <button type="button" className="btn btn-primary me-3" onClick={() => goNotificacao()}>
                Notificações <span className="badge badge-light">{temnotificacao}</span>
              </button>
            )}
          </div>
        </div>
      </nav> */}

      {/* Sidebar direita */}
       
      <div className={`sidebar-right ${sidebarExpanded ? 'expanded' : ''}`}>
        {/* Botão toggle */}
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <i className={`fas ${sidebarExpanded ? 'fa-times' : 'fa-bars'}`}></i>
        </button>

        {/* Logo no topo */}
        <div className="sidebar-logo">
          <img src={LOGO} alt="Logo" onClick={() => navigate('/')} />
        </div>

        {/* Menu items */}
        <div className="sidebar-menu">
          {/* Home */}
          <div className="menu-item">
            <button 
              className="menu-icon" 
              onClick={() => navigate('/')}
              title="Home"
            >
              <i className="fas fa-home"></i>
              <span className="menu-text">Home</span>
            </button>
          </div>

          {/* Turismo */}
          <div className="menu-item">
            <button 
              className="menu-icon" 
              onClick={() => navigate('/turismo')}
              title="Turismo"
            >
              <i className="fas fa-map-marker-alt"></i>
              <span className="menu-text">Turismo</span>
            </button>
          </div>

          {/* Meu menu */}
          <div className="menu-item">
            <button 
              className={`menu-icon ${activeSection === 'meu' ? 'active' : ''}`}
              onClick={() => toggleSection('meu')}
              title="Meu Menu"
            >
              <i className="fas fa-user"></i>
              <span className="menu-text">Meu {localStorage.getItem('nome')}</span>
            </button>
            {activeSection === 'meu' && (
              <div className="submenu">
                <Link to="/meu/participantes" className="submenu-item">
                  <i className="fas fa-users"></i>
                  <span>Participantes</span>
                </Link>
                <Link to="/meu/sorteados" className="submenu-item">
                  <i className="fas fa-trophy"></i>
                  <span>Sorteados</span>
                </Link>
                <Link to="/meu/extrato" className="submenu-item">
                  <i className="fas fa-file-alt"></i>
                  <span>Extrato</span>
                </Link>
                <Link to="/login" className="submenu-item">
                  <i className="fas fa-sign-out-alt"></i>
                  <span>Sair</span>
                </Link>
              </div>
            )}
          </div>

          {/* Menu Parceiro */}
          {logadop && (
            <div className="menu-item">
              <button 
                className={`menu-icon ${activeSection === 'parceiro' ? 'active' : ''}`}
                onClick={() => toggleSection('parceiro')}
                title="Parceiro"
              >
                <i className="fas fa-handshake"></i>
                <span className="menu-text">Parceiro</span>
              </button>
              {activeSection === 'parceiro' && (
                <div className="submenu">
                  <Link to="/parceiro/aprovaavaliacao" className="submenu-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Aprova Avaliação</span>
                  </Link>
                  <Link to="/parceiro/vender" className="submenu-item">
                    <i className="fas fa-shopping-cart"></i>
                    <span>Vender</span>
                  </Link>
                  <Link to="/admin/estabelecimento" className="submenu-item">
                    <i className="fas fa-store"></i>
                    <span>Estabelecimento</span>
                  </Link>
                  <Link to="/parceiro/login" className="submenu-item">
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Sair</span>
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* Menu Administrador */}
          {logadoa && (
            <>
              <div className="menu-item">
                <button 
                  className={`menu-icon ${activeSection === 'admin' ? 'active' : ''}`}
                  onClick={() => toggleSection('admin')}
                  title="Administrador"
                >
                  <i className="fas fa-user-shield"></i>
                  <span className="menu-text">Administrador</span>
                </button>
                {activeSection === 'admin' && (
                  <div className="submenu">
                    <Link to="/admin/home" className="submenu-item">
                      <i className="fas fa-tachometer-alt"></i>
                      <span>Dashboard</span>
                    </Link>
                    <Link to="/admin/aprovaavaliacao" className="submenu-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Aprova Avaliação</span>
                    </Link>
                    <Link to="/admin/vender" className="submenu-item">
                      <i className="fas fa-shopping-cart"></i>
                      <span>Vender</span>
                    </Link>
                    <Link to="/admin/campanha" className="submenu-item">
                      <i className="fas fa-bullhorn"></i>
                      <span>Campanha</span>
                    </Link>
                    <Link to="/admin/estabelecimento" className="submenu-item">
                      <i className="fas fa-store"></i>
                      <span>Estabelecimento</span>
                    </Link>
                    <Link to="/admin/contemplado" className="submenu-item">
                      <i className="fas fa-award"></i>
                      <span>Contemplado</span>
                    </Link>
                    <Link to="/admin/notificacao" className="submenu-item">
                      <i className="fas fa-bell"></i>
                      <span>Notificação</span>
                    </Link>
                    <Link to="/admin/aviso" className="submenu-item">
                      <i className="fas fa-exclamation-triangle"></i>
                      <span>Avisos</span>
                    </Link>
                    <Link to="/admin/promocoes" className="submenu-item">
                      <i className="fas fa-tags"></i>
                      <span>Promoções</span>
                    </Link>
                    <Link to="/admin/turismo" className="submenu-item">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>Turismo</span>
                    </Link>
                    <Link to="/admin/cashback" className="submenu-item">
                      <i className="fas fa-money-bill-wave"></i>
                      <span>CashBack</span>
                    </Link>
                    <Link to="/admin/login" className="submenu-item">
                      <i className="fas fa-sign-out-alt"></i>
                      <span>Sair</span>
                    </Link>
                  </div>
                )}
              </div>
              
              {/* Seletor de cidade */}
              <div className="menu-item city-selector">
                <div className="menu-icon">
                  <i className="fas fa-map-pin"></i>
                  <span className="menu-text">Cidade</span>
                </div>
                {sidebarExpanded && (
                  <div className="city-select-container">
                    <SelectCidade
                      cod_cidade={cod_cidade}
                      SalvarCidade={SalvarCidade}
                      cidades={cidades}
                      className="form-select"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      
      {/* Overlay para dispositivos móveis */}
      <div 
        className={`sidebar-overlay ${sidebarExpanded ? 'active' : ''}`}
        onClick={() => setSidebarExpanded(false)}
      ></div>
    </>
  )
}

export default HOMENAVEGACAO;